import React from 'react';
import FormEdit from '../../../components/common/Forms/FormEdit';

/**
 * ToFormEdit - Page wrapper for editing filled Technical Office forms
 * Used for navigation in routes/index.tsx
 */
const ToFormEdit: React.FC = () => {
  return <FormEdit />;
};

export default ToFormEdit;
